module.exports = __webpack_public_path__ + "static/duftstoevchen_1.05614b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/duftstoevchen_1.jpg
// module id = 555
// module chunks = 35783957827783